<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="700px">
    <div slot="content">
      <div class="title-bar title-h4">DB 정보</div>
      <el-form ref="dbSettingForm" :rules="rules" :model="formData">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="dbSettingId" label="ID">
              <el-input size="small" placeholder="아이디를 입력해주세요" :disabled="popupMode === 'update'" v-model="formData.dbSettingId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dbSettingName" label="DB접속명">
              <el-input size="small" placeholder="DB접속명을 입력해주세요" v-model="formData.dbSettingName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15" class="db-setting-form">
          <el-col :span="7">
            <el-form-item prop="dbType" label="DB 종류">
              <el-select size="small" v-model="formData.dbType" @change="onObjtypeChange">
                <el-option v-for="item in dbTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="dbConnAddress" label="DB 주소">
              <el-input size="small" v-model="formData.dbConnAddress" placeholder="DB주소를 입력해주세요"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="dbConnPort" label="DB 포트">
              <el-input size="small" v-model="formData.dbConnPort" @change="onChangePort" placeholder="DB포트를 입력해주세요"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15" class="db-setting-form">
          <el-col :span="7">
            <el-form-item prop="dbConnName" label="DB명">
              <el-input size="small" placeholder="DB명을 입력해주세요" v-model="formData.dbConnName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="dbConnUserid" label="USER ID">
              <el-input size="small" v-model="formData.dbConnUserid" placeholder="아이디를 입력해주세요"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="dbConnUserpw" label="USER PASSWORD">
              <el-input size="small" type="password" v-model="formData.dbConnUserpw" placeholder="패스워드를 입력해주세요"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isEmpty, findIndex, toNumber, isNaN, cloneDeep, assign } from 'lodash';
import msgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';
import dbmsApi from '@/api/settings/common/device-registration-dbms';

export default {
  name: 'WE2eDbSettingInfoPopup',
  props: {
    dbTypeList: {
      type: Array,
    },
  },
  data() {
    return {
      title: '',
      popupMode: 'add',
      formData: {
        dbSettingId: '',
        dbSettingName: '',
        dbType: 'MYSQL',
        dbConnAddress: '',
        dbConnPort: 3306,
        dbConnName: '',
        dbConnUserid: '',
        dbConnUserpw: '',
        dbPortList: [],
      },
      formOriginData: {
        dbConnPort: 0,
      },
      rules: {
        dbSettingId: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
        dbSettingName: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
    };
  },
  methods: {
    open(popupMode, payload) {
      this.$refs.slidingPopup.open();
      this.loadDbPort();
      this.$nextTick(() => {
        this.$refs.dbSettingForm.resetFields();
        this.popupMode = popupMode;
        if (popupMode === 'update') {
          this.title = 'DB 설정 수정';
          this.formData = cloneDeep(payload);
          this.formOriginData = cloneDeep(this.formData);
        } else {
          this.title = 'DB 설정 추가';
        }
      });
    },
    // close 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 기본 DB 포트 목록을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDbPort() {
      dbmsApi.getDbPortList().then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          this.dbPortList = response.data.data;
          this.setDefaultDbPort(this.formData.dbType);
        }
      });
    },
    /**
     * DB 종류에 맞는 기본 포트를 설정한다.
     * @author Ju
     * @param  {[type]} dbType [description]
     */
    setDefaultDbPort(dbType) {
      const index = findIndex(this.dbPortList, (item) => item.basicinfoSubid === dbType);
      if (index >= 0) {
        this.onChangePort(this.dbPortList[index].basicinfoSubvalueInteger);
      }
    },
    onObjtypeChange(val) {
      this.setDefaultDbPort(val);
    },
    onChangePort(value) {
      if (!isNaN(toNumber(value))) {
        this.formData.dbConnPort = toNumber(value);
      } else {
        this.formData.dbConnPort = this.formOriginData.dbConnPort;
      }
    },
    onSaveButton() {
      this.$refs.dbSettingForm
        .validate()
        .then((valiResponse) => {
          const target = '데이터베이스 설정';
          const action = msgUtil.action.SAVE;
          const encryptTargetData = createEncryptTargetData(this.formData, ['dbConnUserpw']);
          getRsaEncrypt(encryptTargetData)
            .then((encryptData) => {
              if (valiResponse) {
                if (this.popupMode === 'update') {
                  // 수정 저장
                  DeviceRegistrationE2eApi.updateDbList(assign(cloneDeep(this.formData), encryptData))
                    .then((response) => {
                      const result = response.data;
                      if (result.success === true) {
                        this.$message(msgUtil.getResultMsgData(action, target, true));
                        this.clickCloseBtn();
                        this.$emit('load-data');
                      } else {
                        this.$message(msgUtil.getResultMsgData(action, target, false));
                      }
                    })
                    .catch(() => {
                      this.$message(msgUtil.getResultMsgData(action, target, false));
                    });
                } else {
                  // 새로운 DB-setting 저장
                  DeviceRegistrationE2eApi.insertDbList(assign(cloneDeep(this.formData), encryptData))
                    .then((response) => {
                      const result = response.data;
                      if (result.success === true) {
                        this.$message(msgUtil.getResultMsgData(action, target, true));
                        this.$emit('load-data');
                        this.clickCloseBtn();
                      } else {
                        this.$message(msgUtil.getResultMsgData(action, target, false));
                      }
                    })
                    .catch(() => {
                      this.$message(msgUtil.getResultMsgData(action, target, false));
                    });
                }
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/popup/E2eDbSettingInfoPopup.vue